import { Toast } from 'antd-mobile'

export const handleWebShare = async (shareUrl: string) => {
  const shareData = {
    title: '优查查抽奖活动',
    text: '快来参与优查查抽奖活动，赢取丰厚奖品！',
    url: shareUrl,
  }

  try {
    if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
      await navigator.share(shareData)
      Toast.show({
        content: (
          <div style={{ textAlign: 'center', padding: '8px 0' }}>
            <div style={{ fontSize: 18, marginBottom: 8 }}>✅</div>
            <div style={{ fontSize: 14, fontWeight: 600 }}>分享成功</div>
            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>感谢您的分享</div>
          </div>
        ),
        position: 'center',
        duration: 2000,
      })
    } else {
      await handleCopyLink(shareUrl)
    }
  } catch (error) {
    handleBrowserShare()
  }
}

export const handleCopyLink = async (shareUrl: string) => {
  await navigator.clipboard.writeText(shareUrl)
  Toast.show({
    content: (
      <div style={{ textAlign: 'center', padding: '8px 0' }}>
        <div style={{ fontSize: 18, marginBottom: 8 }}>🔗</div>
        <div style={{ fontSize: 14, fontWeight: 600 }}>链接已复制到剪贴板</div>
        <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>可以粘贴到微信、朋友圈等</div>
      </div>
    ),
    position: 'center',
    duration: 2500,
  })
}

export const handleBrowserShare = () => {
  Toast.show({
    content: (
      <div style={{ textAlign: 'center', padding: '8px 0' }}>
        <div style={{ fontSize: 18, marginBottom: 8 }}>📤</div>
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>请使用浏览器分享功能</div>
        <div style={{ fontSize: 12, color: '#666' }}>点击浏览器菜单中的"分享"按钮</div>
      </div>
    ),
    position: 'center',
    duration: 2500,
  })
}
